import {defineStore} from 'pinia'
import {useContractStore} from "@/stores/contract"
import {IPromotionResource, IPromotionsTotals} from "@/interface/services/response/promotion.interface"
import PromotionService from "@/services/promotionService"

export const usePromotionStore = defineStore('promotion', {
    state: (): IPromotionState => ({
        promotions: null,
        totals: {} as IPromotionsTotals,
        lastUpdate: null,
    }),
    actions: {
        async initPromotionsFromContracts(ids: number[]) {
            const response = await PromotionService.getPromotionsFromContracts(ids);
            this.promotions = response.promotions ?? [];
            this.totals = response.totals;
            this.lastUpdate = new Date();
        }
    },
    getters: {
        currentContractPromotions(state: IPromotionState) {
            return (active: boolean) : IPromotionResource[]|[] => {
                const contractStore = useContractStore()
                if (!contractStore.currentContract || !this.promotions) {
                    return [];
                }
                return this.promotions.filter(promotion => promotion.contract_id === contractStore.currentContract?.id);
            }
        }
    },
    persist: true
})

interface IPromotionState {
    promotions: IPromotionResource[]|null,
    totals: IPromotionsTotals|null,
    lastUpdate: Date|null,
}

export type PromotionStore = ReturnType<typeof usePromotionStore>